import api from "../api/axios"

const apiBase = String(process.env.REACT_APP_API_URL || "http://localhost:8080/api").replace(
  /\/$/,
  ""
)

/** Fetch public sans Bearer (évite redirection login). */
async function publicFetch(path, options = {}) {
  const res = await fetch(`${apiBase}${path}`, {
    ...options,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = new Error(data.message || data.error || `HTTP ${res.status}`)
    err.status = res.status
    err.data = data
    throw err
  }
  return data
}

export async function createSelfieLink(memberId, { ttlSeconds = 900 } = {}) {
  const res = await api.post(`/members/${memberId}/selfie-link`, {
    frontendOrigin: window.location.origin,
    ttlSeconds,
  })
  return res.data
}

export async function fetchSelfieInfo(token) {
  return publicFetch(`/public/selfie?t=${encodeURIComponent(token)}`)
}

export async function uploadSelfie(token, { photo, faceDescriptor = null }) {
  const body = { token, photo }
  if (faceDescriptor) body.faceDescriptor = faceDescriptor
  return publicFetch(`/public/selfie`, {
    method: "POST",
    body: JSON.stringify(body),
  })
}
